import React, { ReactNode, SetStateAction } from 'react';

import ResetButton from '../../../../../../common/filterTable/components/Buttons/ResetButton';
import SearchButton from '../../../../../../common/filterTable/components/Buttons/SearchButton';
import Filters from '../../../../../../common/filterTable/components/Filters/Filters';
import PfhNumberTextFields from '../../../../../../common/filterTable/components/Filters/PfhNumberTextFields';
import ProgramNameSingleSelection from '../../../../../../common/filterTable/components/Filters/ProgramNameSingleSelection';
import ReportCurrencySingleSelection from '../../../../../../common/filterTable/components/Filters/ReportCurrencySingleSelection';
import FilterActions from '../../../../../../common/filterTable/layout/FilterActions';
import FilterGrid from '../../../../../../common/filterTable/layout/FilterGrid';
import DaIdAutoCompleteFilter from '../../../../../../components/DaIdAutoCompleteFilter';
import MonthRangePicker from '../../../../../../components/MonthRangePicker';
import { useGenFilterField } from '../../../../../../utils/ComponentHelper';
import { generateLimitedYearDateTime } from '../../../../../../utils/dateUtils';
import { FilterFields, FilterFieldsKeys } from '../types/FilterFields';

interface FilterSectionProps {
  fields: FilterFields;
  setFields: React.Dispatch<SetStateAction<FilterFields>>;
  onSearch: () => void;
  onReset: () => void;
  DateObj: any;
}

const FilterSection = (props: FilterSectionProps) => {
  const { fields, setFields, onSearch, onReset, DateObj } = props;

  const updateField = (fieldName: string, value: any) => {
    setFields((fields) => {
      return {
        ...fields,
        [fieldName]: value,
      };
    });
  };

  const lastMonth = new Date();
  lastMonth.setMonth(lastMonth.getMonth() - 1);
  const filterFields: ReactNode[] = useGenFilterField([
    [
      'month',
      <MonthRangePicker
        startMonth={fields[FilterFieldsKeys.settlementMonthFrom]}
        endMonth={fields[FilterFieldsKeys.settlementMonthTo]}
        onChangeStartMonth={(value) => updateField(FilterFieldsKeys.settlementMonthFrom, value)}
        onChangeEndMonth={(value) => updateField(FilterFieldsKeys.settlementMonthTo, value)}
        defaultStartMonth={lastMonth}
        defaultEndMonth={lastMonth}
        maxMonth={lastMonth}
        minMonth={generateLimitedYearDateTime(2)}
      />,
    ],
    [
      FilterFieldsKeys.distributorAgentId,
      <DaIdAutoCompleteFilter
        value={fields[FilterFieldsKeys.distributorAgentId]}
        onChange={(value) => updateField(FilterFieldsKeys.distributorAgentId, value)}
        onClear={() => updateField(FilterFieldsKeys.distributorAgentId, '')}
      />,
    ],
    [
      FilterFieldsKeys.programName,
      <ProgramNameSingleSelection
        value={fields[FilterFieldsKeys.programName]}
        onChange={(e) => updateField(FilterFieldsKeys.programName, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.programName, '')}
      />,
    ],
    [
      FilterFieldsKeys.pfhNo,
      <PfhNumberTextFields
        value={fields[FilterFieldsKeys.pfhNo]}
        onChange={(e) => updateField(FilterFieldsKeys.pfhNo, e.target.value)}
      />,
    ],
    [
      FilterFieldsKeys.currency,
      <ReportCurrencySingleSelection
        value={fields[FilterFieldsKeys.currency]}
        onChange={(e) => updateField(FilterFieldsKeys.currency, e.target.value)}
        onClear={() => updateField(FilterFieldsKeys.currency, '')}
      />,
    ],
  ]);

  return (
    <>
      <FilterGrid>
        <Filters filterFields={filterFields} />
      </FilterGrid>
      <FilterActions>
        <SearchButton onSearch={onSearch} />
        <ResetButton onReset={onReset} />
      </FilterActions>
    </>
  );
};

export default FilterSection;
